/**
 * Login Component
 */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI, companyAPI } from '../services/api';
import './Login.css';
import BrandLogo from './BrandLogo';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [context, setContext] = useState(null);
  const [slug, setSlug] = useState(sessionStorage.getItem('company_slug') || '');
  const local = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
  useEffect(() => {
    companyAPI.context().then(setContext).catch(e => setError(e.response?.data?.detail || 'Unable to load company settings. Check that the API server is running and reachable, then reload this page.'));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (local) {
        const companySlug = slug.trim().toLowerCase();
        if (companySlug) sessionStorage.setItem('company_slug', companySlug);
        else sessionStorage.removeItem('company_slug');
      }
      await authAPI.login(email, password);
      navigate('/chat');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (context?.platform && !local) return <div className="login-container"><div className="login-box"><h1><BrandLogo /></h1><p>Open your company’s Quantros address to sign in.</p></div></div>;

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <BrandLogo />
          {!local && context?.company?.name && <h1>{context.company.name}</h1>}
          <p>Sign in to access your analytics dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}

          {local && context?.enabled !== false && <div className="form-group"><label htmlFor="company-slug">Company URL prefix</label><input id="company-slug" required={context?.enabled === true} value={slug} onChange={e => setSlug(e.target.value)} placeholder="acme" /></div>}
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your.email@company.com"
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              autoComplete="current-password"
            />
          </div>

          <button type="submit" disabled={loading} className="login-button">
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

      </div>
    </div>
  );
};

export default Login;
